// extracted by mini-css-extract-plugin
export var avatarBone = "_c-4";
export var buttonBone = "_c-3";
export var continueBone = "_c-a";
export var frame = "_c-1";
export var logoBone = "_c-2";
export var pickerGrid = "_c-d";
export var pitchBone = "_c-9";
export var productBone = "_c-8";
export var sectionBone = "_c-7";
export var shell = "_c-0";
export var skeletonPulse = "_c-b";
export var subtitleBone = "_c-6";
export var titleBone = "_c-5";
export var viewport = "_c-c";